// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_mHh","cls2":"ImpactHubModal-cls2_vIx ImpactHubModal-cls1_mHh"};